import { render, staticRenderFns } from "./RiskFutureAction.vue?vue&type=template&id=1c0d61bf&scoped=true&"
import script from "./RiskFutureAction.vue?vue&type=script&lang=js&"
export * from "./RiskFutureAction.vue?vue&type=script&lang=js&"
import style0 from "./RiskFutureAction.vue?vue&type=style&index=0&id=1c0d61bf&lang=scss&scoped=true&"
import style1 from "./RiskFutureAction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d61bf",
  null
  
)

export default component.exports